
import { Vue, Component } from 'vue-property-decorator';
import { fetchNewslist } from '../api/index';
import { List } from 'vant';
Vue.use(List);

@Component
export default class Message extends Vue {
  vector1: string = require('../assets/vector1.png');
  vector2: string = require('../assets/vector2.png');
  vector3: string = require('../assets/vector3.png');
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  classId: number = 9070;
  mounted() {
    // this.onLoad();
  }
  goDetail(a: any) {
    window.location.href = a;
  }
  onLoad() {
    fetchNewslist(this.page, this.classId, '信息速递').then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data.data[0].list || res.data.data[0].list.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data.data[0].list];
    }
    this.loading = false;
  }
}
